// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"e0596b92","513":"1577a990"}[chunkId] + ".chunk.js";
};